import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { withRenderFlag } from '@beef/react';
import { Button } from '@carnica/ui-kit';
import { Metric } from "../../../../../utils/metric";
import { selectAccountType } from "../../store/selectors";
import { selectMobileConnectionAccumulators } from "../MobileTariff/store";
import { TARIFF_TEXTS } from "../../constants/tariff";
var _ManageTariffButton = function _ManageTariffButton(_ref) {
  var userType = _ref.userType,
    tariffUrl = _ref.tariffUrl;
  var handleManageTariffClick = function handleManageTariffClick(e) {
    e.preventDefault();
    window.location.href = tariffUrl;
  };
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType,
      btnTitle: TARIFF_TEXTS.manage.btnTitle
    }),
    events: {
      fubMetricSideMenu: ['handleManageTariffClick']
    },
    mode: "click",
    "data-t-id": "components-ManageTariffButton"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleManageTariffClick,
    size: "l",
    type: "button",
    view: "tertiary",
    width: "full",
    "data-t-id": "components-ManageTariffButton"
  }, TARIFF_TEXTS.manage.btnTitle));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: !selectMobileConnectionAccumulators(state).length,
    userType: selectAccountType(state)
  };
};
export var ManageTariffButton = compose(connect(mapStateToProps), withRenderFlag)(_ManageTariffButton);